import * as React from "react";
import { CSSTransition } from "react-transition-group";
import {
  Grid,
  Typography,
  Input,
  IconButton,
  Button,
  withStyles,
  FormControl,
  Snackbar,
  TextField,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";
import { Close, ArrowBack } from "@material-ui/icons";
import { observer } from "mobx-react";
import { ProfileStore } from "modules/profile/ProfileStore";
import { ProfileService } from "modules/profile/ProfileService";
import i18n from "i18n";
import * as _ from "lodash";
import { default as firebase } from "common/Firebase";
import { cpf } from "cpf-cnpj-validator";
import * as EmailValidator from "email-validator";
import CircularProgress from "@material-ui/core/CircularProgress";
import classNames from "classnames";

const styles = (theme) => ({
  container: {
    left: 0,
    top: 67,
    zIndex: 3,
    height: "calc(100vh - 67px)",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    "& > :last-child": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  header: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "60px",
  },
  title: {
    lineHeight: "60px",
    fontSize: "16px",
    fontFamily: "Raleway",
    display: "inline-block",
    cursor: "pointer",
  },
  newProject: {
    left: "100%",
    top: 0,
    cursor: "auto",
  },
  closeLayerIcon: {
    right: 20,
    top: 80,
  },
  backLayerIcon: {
    left: 20,
    top: 20,
  },
  layerTitleContainer: {
    marginTop: 80,
  },
  layerSecondTitleContainer: {
    marginTop: 36,
  },
  layerSecondTitleMessage: {
    fontSize: "26px",
    fontFamily: "Raleway",
    fontWeight: 400,
    marginTop: 30,
  },
  layerTitle: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 400,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },

  createAccount: {
    color: "white",
    backgroundColor: "#ABC200",
    ":hover": {
      backgroundColor: "rgba(171, 194, 0, 0.8)",
    },
    fontSize: "14px",
    fontWeight: "400" as any,
    fontfamily: "Raleway",
    letterSpacing: "1px",
    ":disabled": {
      backgroundColor: "#DCDCDC",
      color: "#A3A3A3",
    },
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
    justifyContent: "center" as any,
  },
  chip: {
    margin: "1px 5px",
  },
  soon: {
    position: "relative" as any,
    top: "40%",
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 105,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.34)",
    borderWidth: 1,
    borderRadius: 50,
    height: 21,
    paddingTop: 4,
    fontSize: 10,
  },
  createBlank: {
    position: "relative" as any,
    top: 163.5,
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 130,
    fontSize: "16px",
    fontFamily: "Raleway",
    fontWeight: 500,
  },
  cardImport: {
    backgroundColor: "white",
    transition: "box-shadow 300ms ease-in",
    width: 230,
    height: 230,
    margin: "30px 15px",
    float: "left" as any,
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
  },
  import: {
    width: "100%",
    paddingTop: 25,
    height: 70,
    textAlign: "center" as any,
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: 500,
  },
  root: {
    flexGrow: 1,
  },
  panel: {
    width: 710,
    margin: "0 auto",
    paddingTop: "55px",
  },
  textField: {
    width: "100%",
  },
  authButton: {
    width: "98%",
    minWidth: "230px",
    fontFamily: "Raleway",
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "none" as any,
    borderRadius: "0px",
    display: "flex",
    justifyContent: "center",
    boxShadow: "0px 2px 3px 0px #CFCFCF",
    border: "1px solid #CFCFCF",
    backgroundColor: "#ffffff",
    color: "rgba(0,0,0,0.87)",
    padding: "6.5px 0px",
    transition: "all 0.3s",
    ":hover": {
      color: "#FFFFFF",
      backgroundColor: "rgb(183, 183, 183)",
    },
  },
  facebookBtn: {
    ":hover": {
      background: "#3C5A99",
    },
  },
  buttonGrid: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
  },
  buttonWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  blockBtnAddContributorsLayer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "5%",
  },
  heading: {
    fontSize: "30px",
    color: "#ABC200",
    fontFamily: "Raleway",
  },
  defaultText: {
    fontSize: "16px",
    padding: "8px 0px 48px 0px",
  },
});

type IProps = {
  classes: any;
};

@observer
class LayerAddUser extends React.Component<IProps> {
  state = {
    disabled: false,
    snack: false,
    index: 0,
    open: false,
    path: window.location.pathname,
    password: "",
    showPassword: false,
    email: "",
    name: "",
    message: "",
    redirect: false,
    cpf: "",
    loading: false,
    success: false,
  };

  enableButtonCreateAccount = () => {
    return this.state.name && this.state.cpf && this.state.email;
  };

  handleCloseLayerAdd = () => {
    ProfileStore.layerAdd = false;
    this.setState({
      index: 0,
      location: new Array(),
      name: "",
      cpf: "",
      email: "",
      disabled: false,
    });
  };

  handleBack = () => {
    this.setState({ index: 0 });
  };

  handleSnackClose = () => {
    this.setState({ snack: false });
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  private ShowMessage(message: any) {
    if (message != null) {
      if (message == "auth/account-exists-with-different-credential") {
        this.setState({ message: i18n.login.accountExistsDifferent });
      }
      if (message == "auth/email-already-in-use") {
        this.setState({ message: i18n.login.emailAlreadyInUse });
      }

      if (message == "auth/email-already-exists") {
        this.setState({ message: i18n.login.emailAlreadyInUse });
      }
      if (message == "auth/user-created") {
        this.setState({ message: i18n.login.userCreated });
      }
      if (message === "auth/weak-password") {
        this.setState({ message: i18n.login.passwordLength });
      }
      if (message === "auth/wrong-password") {
        this.setState({ message: i18n.login.wrongPassword });
      }
      if (message == "isntCpf") {
        this.setState({ message: i18n.login.isntCpf });
      }
      if (message == "isntEmail") {
        this.setState({ message: i18n.login.isntEmail });
      }

      this.setState({ open: true });
    }
  }

  /**
   * Executa rotina para criar um usuário colaborador.
   * @method handleClickCreateAcount
   * @category Users
   */
  handleClickCreateAcount = async () => {
    const addUser = firebase.functions().httpsCallable("addUser");
    let isCpf = cpf.isValid(this.state.cpf);
    let isEmail = EmailValidator.validate(this.state.email);

    if (!isCpf) {
      this.ShowMessage("isntCpf");
    }

    if (!isEmail) {
      this.ShowMessage("isntEmail");
    }

    if (isCpf && isEmail) {
      this.setState({
        success: false,
        loading: true,
      });

      let companyUid = await ProfileService.getCompanyID();

      await addUser({
        email: this.state.email,
        emailVerified: false,
        password: this.state.cpf,
        displayName: this.state.name,
        disabled: false,
        companyUid: companyUid,
        currentUser: ProfileService.getUserId(),
      }).then(async (response) => {
        if (response.data.message == "auth/user-created") {
          this.ShowMessage(response.data.message);

          this.state.email = "";
          this.state.name = "";
          this.state.cpf = "";

          let uid = ProfileService.getUserId();
          await ProfileService.getUsers(uid);

          setTimeout(() => {
            this.setState({
              success: true,
              loading: false,
            });
            ProfileStore.layerAdd = false;
          }, 3000);
        }

        if (response.data.message == "auth/email-already-exists") {
          this.ShowMessage(response.data.message);
          this.state.email = "";
          this.state.name = "";
          this.state.cpf = "";

          this.setState({
            success: true,
            loading: false,
          });
        }
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    return (
      <CSSTransition
        in={ProfileStore.layerAdd}
        enter={true}
        exit={true}
        timeout={300}
        classNames={{
          enter: classes.transitionEnter,
          enterActive: classes.transitionEnterActive,
          exit: classes.transitionLeave,
          exitActive: classes.transitionLeaveActive,
        }}
        unmountOnExit
      >
        <Grid
          container
          className={classes.container}
          style={{ position: "absolute" }}
        >
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={this.state.snack}
            autoHideDuration={6000}
            onClose={this.handleSnackClose}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={
              <span id="message-id">
                {i18n.rateLibraries.layerAdd.supportFileType}
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackClose}>
                <Close />
              </IconButton>,
            ]}
          />

          <Grid container xs={12} className={classes.header}>
            <Grid item xs={2} style={{ textAlign: "center" }}>
              <Typography
                className={classes.title}
                style={{ textAlign: "center", position: "relative" }}
                onClick={this.handleCloseLayerAdd}
              >
                {i18n.profile.tab.myProfile}
                <span
                  className={classes.newProject}
                  style={{ position: "absolute", whiteSpace: "nowrap" }}
                >
                  &ensp;{">"}&ensp;
                  <span style={{ fontWeight: 700 }}>
                    {i18n.contributors.addContributors}
                  </span>
                </span>
              </Typography>
            </Grid>
          </Grid>

          <IconButton
            onClick={this.handleCloseLayerAdd}
            className={classes.closeLayerIcon}
            style={{ position: "absolute", zIndex: 2 }}
          >
            <Close fontSize="small" />
          </IconButton>

          <div className={classes.root}>
            {/* {this.renderRedirect()} */}
            <form>
              <div className={classes.panel}>
                {/* <div className={classes.heading}>
                                    {i18n.login.createAccountCaption}
                                </div> */}
                {/* <div className={classes.defaultText}>
                                    {i18n.login.createAccountMessage}
                                </div> */}

                <TextField
                  inputProps={{
                    maxlength: "30",
                  }}
                  id="txtName"
                  label={i18n.name}
                  className={classes.textField}
                  value={this.state.name}
                  onChange={this.handleChange("name")}
                  margin="normal"
                  style={{ marginLeft: 0 }}
                />

                <TextField
                  inputProps={{
                    maxlength: "11",
                  }}
                  id="txtName"
                  label={i18n.cpf}
                  className={classes.textField}
                  value={this.state.cpf}
                  onChange={this.handleChange("cpf")}
                  margin="normal"
                  style={{ marginLeft: 0 }}
                />
                <div>
                  <TextField
                    id="txtEmail"
                    label="E-mail"
                    className={classes.textField}
                    value={this.state.email}
                    onChange={this.handleChange("email")}
                    margin="normal"
                    type="email"
                    style={{ marginLeft: 0 }}
                  />
                </div>
                <div className={classes.blockBtnAddContributorsLayer}>
                  {loading && (
                    <CircularProgress
                      size={50}
                      className={classes.fabProgress}
                    />
                  )}
                </div>
                <div
                  style={{ display: "flex", justifyContent: "center" }}
                  className={classes.wrapper}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    // style={{ width: '100%' }}
                    // size="large"
                    className={buttonClassname}
                    disabled={loading || !this.enableButtonCreateAccount()}
                    onClick={() => this.handleClickCreateAcount()}
                  >
                    {i18n.profile.contributors.createContributor}
                  </Button>
                </div>
              </div>
            </form>

            <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              open={this.state.open}
              onClose={this.handleCloseSnack}
              ContentProps={{
                "aria-describedby": "message-id",
              }}
              message={<span id="message-id">{this.state.message}</span>}
            />
          </div>
        </Grid>
      </CSSTransition>
    );
  }
}

export default withStyles(styles)(LayerAddUser);



// WEBPACK FOOTER //
// ./src/modules/profile/components/pages/LayerAddUser.tsx